import { useMedia } from "react-use";
import { MQ } from "../constants/breakpoints";

export default function useBreakpoint() {
  const isPhone = useMedia(MQ.phone);
  const isSmall = useMedia(MQ.small);
  const isNavDrawer = useMedia(MQ.navDrawer);
  const isWide = useMedia(MQ.wide);
  const isTouch = useMedia(MQ.touch);

  return { isPhone, isSmall, isNavDrawer, isWide, isTouch };
}
